import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import i18next from "i18next";

import { DatePickerInput } from '../DatePickerInput';
import { ChecklistConfigsService } from '../../services';

const CorrectiveActionsReportForm = ({ availableGroupingValues, onSubmit, onError }) => {
  const DATE_RANGE_OPTIONS = [
    {value: 'day', label: i18next.t('day')},
    {value: 'week', label: i18next.t('week')}
  ];

  const FOCUS_OPTIONS = [
    {value: 'task', label: 'Tasks'},
    {value: 'location', label: 'Locations'},
    {value: 'checklist', label: 'Checklists'},
    {value: 'detail', label: 'Details'}
  ];

  const ALL_GROUPING = {value: -1, label: 'All', grouping: {id: -1}};

  const [dateRange, setDateRange] = useState(DATE_RANGE_OPTIONS[0]);
  const [startDate, setStartDate] = useState(null);
  const [focus, setFocus] = useState(FOCUS_OPTIONS[0])
  const [focusedAvailableGroupingValues, setFocusedAvailableGroupingValues] = useState(availableGroupingValues);
  const [selectedGrouping, setSelectedGrouping] = useState(null);
  const [filteredChecklistOptions, setFilteredChecklistOptions] = useState([]);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [checklistsLoading, setChecklistsLoading] = useState(false);

  useEffect(() => {
    setSelectedChecklist(null);
    setFilteredChecklistOptions([]);

    if (focus.value == 'detail') {
      setSelectedGrouping(null);
      setFocusedAvailableGroupingValues(availableGroupingValues);
    } else if (focus.value == 'task' || focus.value == 'checklist') {
      setSelectedGrouping(null);
      setFocusedAvailableGroupingValues([ALL_GROUPING, ...availableGroupingValues]);
    } else {
      setFocusedAvailableGroupingValues([ALL_GROUPING]);
      setSelectedGrouping(ALL_GROUPING);
    }
  }, [focus]);
  
  useEffect(() => {
    setStartDate(null);
  }, [dateRange]);

  useEffect(() => {   
    if (selectedGrouping) {
      setChecklistsLoading(true);
      ChecklistConfigsService.listAll(selectedGrouping.value == -1 ? null : selectedGrouping.value).then(({ checklists }) => {
        let options = [{ label: "All", value: -1, checklist: null }];

        checklists.sort((a, b) => a.name.localeCompare(b.name))
                  .forEach((checklist) => options.push({ label: `${checklist.name} (V${checklist.version})`, value: checklist.id, checklist: checklist }));

        setFilteredChecklistOptions(options);
        setSelectedChecklist(options[0]);

        setChecklistsLoading(false);
      }).catch((error) => {
        setChecklistsLoading(false);
        onError('Error loading available checklists.');
        console.error(error);
      });
    }
  }, [selectedGrouping]);

  useEffect(() => {
    onSubmit(null);
  }, [focus]);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    onSubmit({ focus: focus.value, selectedGrouping, selectedChecklist, dateRange, startDate });
  }, [onSubmit, dateRange, startDate, selectedGrouping, selectedChecklist, focus]);

  return (
    <div className="op-content-box filter-box" style={{marginBottom: 20}}>

      <form onSubmit={handleSubmit}>

        <ul className="list-inline clearfix">
          <li className="pull-left box-label"><h4 className="remove-margin-bottom">{i18next.t('filters')}</h4></li>
        </ul>

        <div className = "row" style={{paddingBottom: 15}}>
          <div className="col-sm-3">
            <label>Focus</label>
            <Select
                options={FOCUS_OPTIONS}
                clearable={false}
                value={focus}
                onChange={setFocus}
                searchable={false}
                classNamePrefix="react-select"
              />
          </div>
        </div>

        <div className = "row">
          <div className="col-sm-3">
            <label>{i18next.t('timeframe')}</label>
            <Select
                options={DATE_RANGE_OPTIONS}
                clearable={false}
                value={dateRange}
                onChange={setDateRange}
                searchable={false}
                classNamePrefix="react-select"
                placeholder ={ i18next.t('select-a-timeframe') }
              />
          </div>

          <div className="pull-left" style={{"maxWidth": "150px", margin: "0px 0px 0px 10px"}}>
              <label>{ i18next.t('start-date') }</label>
              <DatePickerInput
                input={{value: startDate}}
                meta={{}}
                onDayChange={setStartDate}
                dayPickerProps={{
                    disabledDays: dateRange.value == 'day' ? {} : {daysOfWeek: [1,2,3,4,5,6]}
                }}
              />
          </div>

          <div className="col-sm-3">
            {focus.value != 'location' && <label>{ i18next.t('location') }</label>}
            {focus.value != 'location' && <Select
                options={focusedAvailableGroupingValues}
                clearable={false}
                value={selectedGrouping}
                onChange={setSelectedGrouping}
                searchable={false}
                classNamePrefix="react-select"
                placeholder={ i18next.t('select-a-location') }
              />}
          </div>

          <div className="col-sm-3">
            {focus.value != 'checklist' && <label>{ i18next.t('checklist') }</label>}
            {focus.value != 'checklist' && <Select
                options={filteredChecklistOptions}
                clearable={false}
                value={selectedChecklist}
                onChange={setSelectedChecklist}
                searchable={false}
                classNamePrefix="react-select"
                isLoading={checklistsLoading}
                placeholder={"Select a Checklist"}
              />}
          </div>

          <div className="pull-left">
            <label style={{visibility: 'hidden'}}>{ i18next.t('run-report') }</label>
            <ul className="list-inline clearfix">
              <li className="pull-left" style={{marginLeft: '15px'}}>
                <button type="submit" className="btn btn-sm btn-default pull-right" disabled={!(selectedGrouping && startDate)}>{ i18next.t('form-labels.run-report') }</button>
              </li>
            </ul>
          </div>          

        </div>
      </form>
    </div>
  );

}

export default CorrectiveActionsReportForm;
